"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.order = exports.orderTypes = void 0;
const LRUCache = require("lru-cache");
const TermTransformer_1 = require("../transformers/TermTransformer");
// Determine the relative numerical order of the two given terms.
function orderTypes(litA, litB, isAscending, typeDiscoveryCallback, typeCache, enableExtendedXSDTypes) {
    const openWorldType = {
        discoverer: typeDiscoveryCallback || (() => 'term'),
        cache: typeCache || new LRUCache(),
    };
    const termTransformer = new TermTransformer_1.TermTransformer(openWorldType, enableExtendedXSDTypes || false);
    if (litA && litA.termType === 'Literal' && litB && litB.termType === 'Literal') {
        const myLitA = termTransformer.transformLiteral(litA);
        const myLitB = termTransformer.transformLiteral(litB);
        return order(myLitA, myLitB, isAscending);
    }
    return 0;
}
exports.orderTypes = orderTypes;
// Effective ordering
function order(orderA, orderB, isAscending) {
    if (orderA.typedValue === orderB.typedValue) {
        return 0;
    }
    return orderA.typedValue > orderB.typedValue === isAscending ? 1 : -1;
}
exports.order = order;
//# sourceMappingURL=Ordering.js.map